import requests from "./httpService";

const PaymentgatewayServices = {
  getAllGatewaypayment: async () => {
    return requests.get(`/paymentgateway/getallgateway`);
  },

  getGatewayById: async (id) => {
    return requests.get(`/paymentgateway/paymentgateway/${id}`);
  },

  updateGatewayCharge: async (id, body) => {
    return requests.put(`/paymentgateway/update-gateway/${id}`, body);
  },
};

export default PaymentgatewayServices;
